// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import '@rails/actiontext';
import * as ActiveStorage from '@rails/activestorage';
import axios from 'axios';
import 'channels';
import { Popover, Dropdown } from 'bootstrap';
import 'fontawesome-4.7/css/font-awesome.min.css';
import './global/scss/index.scss';
import ahoy from "ahoy.js";
import 'trix';
import "chartkick/chart.js";
import "@hotwired/turbo-rails"

Rails.start();
ActiveStorage.start();

// Configure axios
const csrfToken = document.querySelector('meta[name=csrf-token]').content;
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

// Setup React UJS for Turbo compatibility
var componentRequireContext = require.context('components', true);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);

// Manually handle React component mounting/unmounting for Turbo
document.addEventListener('turbo:load', function() {
  ReactRailsUJS.mountComponents();
});

document.addEventListener('turbo:before-render', function() {
  ReactRailsUJS.unmountComponents();
});

document.addEventListener('turbo:load', function () {
  // Initialize popovers
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(popover => new Popover(popover));

  // Initialize dropdowns manually
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(dropdown => new Dropdown(dropdown));

  var parts = window.location.host.split('.')
  var subdomain = parts.splice(0, parts.length - 2).join('.')
  ahoy.trackView({...window.railsParams||{}, subdomain});
});

/*
 * UJS to show/hide a element based on a checkbox or radio selection
 * Usage:
 *    <input type="checkbox" data-checkbox-show="#some-query-selector" />
 *    <div id="some-query-selector">...</div>
 * Now when the checkbox is checked, the element will be shown, otherwise hidden.
 * For the inverse behavior, use data-checkbox-hide instead of data-checkbox-show.
 * Also works on radio buttons.
 */
document.addEventListener('turbo:load', function () {
  document.querySelectorAll('[data-checkbox-show]').forEach((checkbox) => {
    const selector = checkbox.dataset.checkboxShow;
    const targets = document.querySelectorAll(selector);
    if(!targets.length) return;
    const update = () => {
      if (checkbox.checked) {
        targets.forEach((target) => {
          target.querySelectorAll('input, textarea, select').forEach(el => el.disabled = false);
          target.classList.remove('d-none');
        });
      } else {
        targets.forEach((target) => {
          target.querySelectorAll('input, textarea, select').forEach(el => el.disabled = true);
          target.classList.add('d-none');
        });
      }
    };
    if(checkbox.type === 'radio') {
      // radio buttons needs listeners added to their sibling inputs as well,
      // as they can be de-selected when a sibling is chosen
      document.querySelectorAll(`[name="${checkbox.name}"]`).forEach((radio) => {
        radio.addEventListener('change', update);
      });
    } else {
      checkbox.addEventListener('change', update);
    }
    update();
  });

  document.querySelectorAll('[data-checkbox-hide]').forEach((checkbox) => {
    const selector = checkbox.dataset.checkboxHide;
    const targets = document.querySelectorAll(selector);
    if(!targets.length) return;
    const update = () => {
      if (checkbox.checked) {
        targets.forEach((target) => {
          target.querySelectorAll('input, textarea, select').forEach(el => el.disabled = true);
          target.classList.add('d-none');
        });
      } else {
        targets.forEach((target) => {
          target.querySelectorAll('input, textarea, select').forEach(el => el.disabled = false);
          target.classList.remove('d-none');
        });
      }
    };
    if(checkbox.type === 'radio') {
      // radio buttons needs listeners added to their sibling inputs as well,
      // as they can be de-selected when a sibling is chosen
      document.querySelectorAll(`[name="${checkbox.name}"]`).forEach((radio) => {
        radio.addEventListener('change', update);
      });
    } else {
      checkbox.addEventListener('change', update);
    }
    update();
  });
});

// home/index.html.haml
document.addEventListener('turbo:load', function() {
  if(document.getElementById('get-started')) {
    document.getElementById('get-started').addEventListener('click', function(e) {
      e.preventDefault();

      const targetElement = document.getElementById('select-a-school');
      const scrollTo = targetElement.offsetTop;

      // Smooth scroll to element
      window.scrollTo({
        top: scrollTo - 10,
        behavior: 'smooth'
      });
    });
  }
});

// listings/_form.html.haml
document.addEventListener('turbo:load', function() {
  if(document.getElementById('new-listing-form')) {
    const listingStartDate = document.getElementById('listing_start_date');
    const listingAvailable = document.getElementById('listing_available_now');
    const priceMaxArea = document.querySelector('.price-max-area');
    const listingPriceMax = document.getElementById('listing_price_max');
    const listingPriceRange = document.getElementById('listing_price_range');

    listingAvailable.addEventListener('click', function (e) {
      const isChecked = e.target.checked;
      const date = new Date();
      if (isChecked) {
        listingStartDate.valueAsDate = date;
      } else {
        listingStartDate.value = '';
      }
    });

    listingPriceRange.addEventListener('click', function () {
      priceMaxArea.classList.toggle('invisible');
      priceMaxArea.classList.toggle('visible');
      listingPriceMax.value = '';
    });

    const listingRelationship = document.getElementById('listing_relationship');
    listingRelationship.addEventListener('change', function (e) {
      console.log(e.target.value);
      const relationshipOther = document.querySelector('.relationship-other');
      if(e.target.value === 'Other') {
        relationshipOther.classList.remove('d-none');
        relationshipOther.classList.add('d-block');
      } else {
        relationshipOther.classList.remove('d-block');
        relationshipOther.classList.add('d-none');
      }
    });
  }
});


// pricing/bulk.html.haml
document.addEventListener('turbo:load', function() {
  if(document.querySelector('.pricing.bulk')) {
    // Helper function to format price
    const formatPrice = (price) => {
      if(parseInt(price) === price) return price;
      return price.toFixed(2);
    };

    const update = () => {
      // Get input values
      const listingsInput = document.getElementById('listings');
      const schoolsInput = document.getElementById('schools');

      let numListings = parseInt(listingsInput.value);
      let numSchools = parseInt(schoolsInput.value);
      numListings = isNaN(numListings) ? 0 : numListings;
      numSchools = isNaN(numSchools) ? 0 : numSchools;

      // Get selected period
      const period = document.querySelector('[name="period"]:checked').value;

      // Calculate prices
      const monthlyPrice = 10 + ((numSchools-1) * 2.5);
      const yearlyPrice = 100 + ((numSchools-1) * 25);

      // Update price displays
      document.getElementById('monthly-price').textContent = `$${formatPrice(monthlyPrice)}`;
      document.getElementById('yearly-price').textContent = `$${formatPrice(yearlyPrice)}`;

      const price = period === 'month' ? monthlyPrice : yearlyPrice;
      const totalPrice = price * numListings;

      // Update UI based on validation
      const nextButtons = document.querySelectorAll('.next-btn');
      const totalElement = document.getElementById('total');
      const summaryElement = document.getElementById('summary');

      if(numListings < 5 || numSchools < 1) {
        nextButtons.forEach(btn => btn.disabled = true);
        totalElement.innerHTML = '';
        summaryElement.innerHTML = 'Please add at least 5 listings and 1 school.';
      } else {
        nextButtons.forEach(btn => btn.disabled = false);
        totalElement.innerHTML = `Total: $${formatPrice(totalPrice)} per ${period}`;
        summaryElement.innerHTML = `${numListings} listings at $${formatPrice(price)} per ${period} each`;
      }
    };

    // Add event listeners
    document.getElementById('listings').addEventListener('input', update);

    // Add listener to all period radio buttons
    document.querySelectorAll('[name="period"]').forEach(radio => {
      radio.addEventListener('change', update);
    });

    document.getElementById('schools').addEventListener('change', update);

    // Initial update
    update();
  }
});
